import type { IStaticBlocksData } from '@dcentralexpedientedigital/fe-shared/types/config.interface';

export function isBlocks(blocksData: unknown): blocksData is IStaticBlocksData {
    return (
        !!blocksData &&
        blocksData !== 'undefined' &&
        typeof blocksData === 'object' &&
        'blocks' in blocksData
    );
}
